import { Exclude, Expose } from "class-transformer";

@Exclude()
export class UpdateInnBindDto {
    @Expose({ name: "staffMemberId" })
    readonly staff_id: number;

    @Expose()
    readonly inn: string;
}
